import { c as _c } from "react/compiler-runtime";
interface BottomNavMyIconProps {
  className?: string;
}
const BottomNavMyIcon = t0 => {
  const $ = _c(4);
  const {
    className
  } = t0;
  const t1 = `${className}`;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M10 10C10 9.0111 10.2932 8.0444 10.8427 7.22215C11.3921 6.39991 12.173 5.75904 13.0866 5.3806C14.0002 5.00217 15.0055 4.90315 15.9755 5.09608C16.9454 5.289 17.8363 5.76521 18.5355 6.46447C19.2348 7.16373 19.711 8.05465 19.9039 9.02455C20.0969 9.99446 19.9978 10.9998 19.6194 11.9134C19.241 12.827 18.6001 13.6079 17.7779 14.1573C16.9556 14.7068 15.9889 15 15 15C13.6744 14.9985 12.4035 14.4712 11.4661 13.5339C10.5288 12.5965 10.0015 11.3256 10 10Z" fill="currentColor" />;
    t3 = <path d="M5 19.75C5 17.817 6.567 16.25 8.5 16.25H21.5C23.433 16.25 25 17.817 25 19.75V23C25 24.1046 24.1046 25 23 25H7C5.89543 25 5 24.1046 5 23V19.75Z" fill="currentColor" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== t1) {
    t4 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" width="30" height="30">{t2}{t3}</svg>;
    $[2] = t1;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export default BottomNavMyIcon;